import React, { useEffect, useContext, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Form, message } from "antd";
import { AppContext } from "../../contexts/AppContext";
import GeneralButton from "../../components/GeneralButton/GeneralButton";
import Toast from "../../components/Toast/Toast";
import "../../styles/globals.css";
import "./QuestionnaireEntryPage.css";
import QuestionnaireInputForm from "../../forms/QuestionnaireInputForm/QuestionnaireInputForm";
import { getMedicalQuestionnaire } from "../../services/service";

/**
 * 問診入力画面用のコンポーネント
 * @param {} なし
 * @return {}  なし
 */
function QuestionnaireEntryPage() {
  const {
    globalQuestionnaire,
    globalMedicalInstitutionName,
    globalAnswerInformation,
    setGlobalMedicalInstitutionName,
    setGlobalQuestionnaire,
    setGlobalAnswerInformation,
    setGlobalQuestionnaireToken,
    setGlobalMedicalInstitutionId,
  } = useContext(AppContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();
  const [errors, setErrors] = useState({});

  /**
   * コンポーネントがマウントされた時
   */
  useEffect(() => {
    window.scrollTo(0, 0);
    // データ読込処理
    const loadDatas = async () => {
      try {
        const useQuery = new URLSearchParams(location.search);
        const token = useQuery.get("token") || null;
        setGlobalQuestionnaireToken(token);

        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1)); // '#'を除去してから解析
        const medicalInstitutionId = params.get("medicalInstitutionId") || null;

        setGlobalMedicalInstitutionId(medicalInstitutionId);

        // 質問情報取得
        const data = await getMedicalQuestionnaire(token);
        setGlobalMedicalInstitutionName(data?.data?.questionnaireMenuName);
        setGlobalQuestionnaire(data?.data?.questionnaireQuestions);
      } catch (error) {
        console.error("Error load data:", error);
      }
    };

    loadDatas();
  }, [location]);

  //入力内容がある場合に表示
  useEffect(() => {
    if (globalAnswerInformation) {
      const inputData = {};

      globalAnswerInformation.forEach((answerInfo) => {
        inputData[`question-${answerInfo.questionId}`] = answerInfo.answer;
      });
      form.setFieldsValue(inputData);
    }
  }, [globalQuestionnaire]);

  /**
   * 予約確認に進むボタン押下時の処理
   * @param {} なし
   * @return {} なし
   */
  const handleConfirmClick = async () => {
    try {
      await form.validateFields();

      const formData = await form.getFieldsValue();
      const answer = globalQuestionnaire?.map((question) => ({
        questionId: question.questionId,
        questionPosition: question.questionPosition,
        contents: question.questionContent,
        answer: formData[`question-${question.questionId}`],
      }));

      setGlobalAnswerInformation(answer);

      // 問診確認画面に遷移
      navigate("/questionnaire-confirm");
    } catch (error) {
      const fieldErrors = error.errorFields.reduce((acc, field) => {
        acc[field.name[0]] = true;
        return acc;
      }, {});
      setErrors(fieldErrors);
      showToast("入力に不備があります。ご確認ください", "error");
    }
  };

  const showToast = (content, type) => {
    const key = `open${Date.now()}`;
    const closeToast = () => {
      message.destroy(key);
    };

    message.open({
      content: <Toast content={content} type="check" onClose={closeToast} />,
      key,
      className: `ant-message-notice-content-${type}`,
    });
  };

  return (
    <div className="questionnaire-entry">
      <div className="main-area">
        <div className="title">{globalMedicalInstitutionName}</div>
        <div className="detail">問診記入をお願いします。</div>
        <div className="form">
          {globalQuestionnaire && globalQuestionnaire.length > 0 && (
            <Form
              form={form}
              name="registration"
              layout="vertical"
              initialValues={{ remember: true }}
            >
              <QuestionnaireInputForm
                questions={globalQuestionnaire}
                form={form}
                errors={errors}
                setErrors={setErrors}
              />
              <Form.Item>
                <GeneralButton
                  buttonLabel={"問診入力確認に進む"}
                  type={
                    Object.values(errors).some((error) => error)
                      ? "disabled"
                      : "primary-blue"
                  }
                  onClick={handleConfirmClick}
                />
              </Form.Item>
            </Form>
          )}
        </div>
      </div>
    </div>
  );
}

export default QuestionnaireEntryPage;
